import SMSSignupModal from 'components/GlobalModals/SMSSignupModal/SMSSignupModal';
import { withSMSSignupModalProps } from 'viewModel/globalModals/smsSignupModal/withSMSSignupModalProps';

const ConnectedSMSSignupModal = withSMSSignupModalProps(SMSSignupModal);

export default ConnectedSMSSignupModal;
